/**
 * Enum for button variant
 */
export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  OutlinePrimary = 'outline-primary',
  PrimarySuccess = 'primary-success',
  linkButton = 'link-button',
}

/**
 * Enum for button type
 */
export enum ButtonType {
  Logout = 'Log out?',
  Register = 'Register',
  Profile = 'Profile',
  Login = 'Log In',
}

/**
 * Enum for login type
 */
export enum LoginType {
  Logout = 'logout',
  Signup = 'signUp',
  Signin = 'signIn',
}

/**
 * Interface for B2C tokenClaims
 */
export interface IdTokenClaims {
  tfp: string;
  extension_FirstName: string;
}

/**
 * Interface for RenderHeader Props
 */
export interface IRenderHeaderProps {
  operatorHeaderText: string;
  operatorMenuArray: Array<any>;
}
